import React from 'react';
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';


const Alert = React.forwardRef(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const SessionNotification = ({open, onClose, message, severity}) => {

    const getAutoHideDuration = () => {
        // Keep success notifications short, but allow longer time for long error messages.
        if (severity === 'success') return 2000;
        const text = String(message || '').trim();
        if (!text) return 5000;

        const words = text.split(/\s+/).filter(Boolean).length;
        // ~250ms per word (~240 wpm) with sane bounds
        const calculated = words * 250;
        return Math.min(20000, Math.max(5000, calculated));
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway' || !open) {
            return;
        }

        onClose()
    };

    return (
        <React.Fragment>
            <Snackbar
                open={open}
                autoHideDuration={getAutoHideDuration()}
                onClose={handleClose}
                sx={{ maxWidth: 'min(720px, calc(100vw - 32px))' }}
            >
                <Alert
                    onClose={handleClose}
                    severity={severity}
                    sx={{
                        width: '100%',
                        '& .MuiAlert-message': { whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
                    }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    )
}

export default SessionNotification